import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import LeadFormButton from '../../../components/LeadFormButton';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Maria Fernanda Oliveira",
      role: "Arquiteta & Designer de Interiores",
      company: "MF Arquitetura",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `A PH Móveis transformou completamente meus projetos. A qualidade artesanal é incomparável e a atenção aos detalhes é impressionante. Cada peça é única e reflete perfeitamente a personalidade dos meus clientes.\n\nJá especifiquei móveis da PH em mais de 20 projetos e sempre recebo elogios. A parceria com Paulo Henrique e sua equipe é fundamental para o sucesso dos meus trabalhos.`,
      project: "Apartamento de 200m² em Moema",
      furniture: "Sala de jantar completa e home office",
      videoThumbnail: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      name: "Roberto Silva Santos",
      role: "Empresário",
      company: "CEO - TechCorp Brasil",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `Quando decidimos mobiliar nossa nova casa, queríamos algo único e especial. A PH Móveis superou todas as expectativas. Cada móvel conta uma história e se integra perfeitamente ao ambiente.\n\nO processo foi transparente do início ao fim. Acompanhamos cada etapa da produção e ficamos impressionados com o cuidado e dedicação da equipe. Recomendo sem hesitação.`,
      project: "Casa de 400m² em Alphaville",
      furniture: "Mobiliário completo para 5 ambientes",
      videoThumbnail: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      name: "Ana Carolina Mendes",
      role: "Médica & Colecionadora de Arte",
      company: "Hospital Sírio-Libanês",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `Como colecionadora de arte, tenho um olhar muito crítico para qualidade e beleza. Os móveis da PH Móveis são verdadeiras obras de arte funcionais. A madeira, os acabamentos, cada detalhe é perfeito.\n\nMinha estante para livros raros é uma peça única que recebe elogios de todos os visitantes. É um investimento que vale cada centavo e que será passado para as próximas gerações.`,
      project: "Consultório médico e biblioteca pessoal",
      furniture: "Estante para livros raros e mesa executiva",
      videoThumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 4,
      name: "Carlos Eduardo Lima",
      role: "Diretor de Hotel",
      company: "Grand Hotel São Paulo",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `Para o nosso hotel de luxo, precisávamos de móveis que transmitissem sofisticação e durabilidade. A PH Móveis entregou exatamente o que buscávamos. Os móveis mantêm sua beleza mesmo com uso intenso.\n\nA sustentabilidade dos materiais também foi um fator decisivo. Nossos hóspedes frequentemente perguntam sobre os móveis, o que demonstra a qualidade excepcional do trabalho.`,
      project: "Suítes presidenciais e áreas comuns",
      furniture: "Mobiliário para 15 suítes de luxo",
      videoThumbnail: "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    }
  ];

  const stats = [
    { number: "500+", label: "Clientes Satisfeitos", icon: "Users" },
    { number: "98%", label: "Taxa de Satisfação", icon: "Heart" },
    { number: "1000+", label: "Projetos Entregues", icon: "CheckCircle" },
    { number: "25", label: "Anos de Experiência", icon: "Award" }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-white to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="MessageSquare" size={16} />
            <span>Depoimentos</span>
          </div>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-6">
            O que Nossos Clientes
            <span className="block text-secondary">Dizem Sobre Nós</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            A satisfação dos nossos clientes é nossa maior conquista. Veja os depoimentos 
            de quem já transformou seus ambientes com nossos móveis artesanais.
          </p>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-gradient-forest rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name={stat?.icon} size={32} color="white" strokeWidth={1.5} />
              </div>
              <div className="text-3xl font-bold text-primary mb-2">{stat?.number}</div>
              <div className="text-text-secondary font-medium">{stat?.label}</div>
            </div>
          ))}
        </div>

        {/* Main Testimonial Display */}
        <div className="bg-white rounded-3xl shadow-premium-lg border border-border overflow-hidden mb-12">
          <div className="grid lg:grid-cols-2">
            {/* Video/Image Section */}
            <div className="relative">
              <Image
                src={testimonials?.[activeTestimonial]?.videoThumbnail}
                alt={`Projeto de ${testimonials?.[activeTestimonial]?.name}`}
                className="w-full h-96 lg:h-full object-cover"
              />
              
              {/* Play Button Overlay */}
              <div className="absolute inset-0 bg-primary/20 flex items-center justify-center">
                <button className="w-20 h-20 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-premium hover:scale-110 transition-transform duration-300">
                  <Icon name="Play" size={32} color="var(--color-primary)" />
                </button>
              </div>

              {/* Project Info */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-premium">
                <h4 className="font-bold text-primary mb-1">{testimonials?.[activeTestimonial]?.project}</h4>
                <p className="text-sm text-text-secondary">{testimonials?.[activeTestimonial]?.furniture}</p>
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="p-8 lg:p-12">
              <div className="space-y-6">
                {/* Rating */}
                <div className="flex items-center space-x-1">
                  {[...Array(testimonials?.[activeTestimonial]?.rating)]?.map((_, i) => (
                    <Icon key={i} name="Star" size={20} color="var(--color-accent)" fill="var(--color-accent)" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <div>
                  <Icon name="Quote" size={32} color="var(--color-accent)" className="mb-4" />
                  <div className="text-text-primary leading-relaxed space-y-4">
                    {testimonials?.[activeTestimonial]?.testimonial?.split('\n\n')?.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>

                {/* Client Info */}
                <div className="flex items-center space-x-4 pt-6 border-t border-border">
                  <div className="w-16 h-16 rounded-full overflow-hidden">
                    <Image
                      src={testimonials?.[activeTestimonial]?.image}
                      alt={testimonials?.[activeTestimonial]?.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-primary">{testimonials?.[activeTestimonial]?.name}</h4>
                    <p className="text-text-secondary">{testimonials?.[activeTestimonial]?.role}</p>
                    <p className="text-sm text-text-secondary">{testimonials?.[activeTestimonial]?.company}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {testimonials?.map((testimonial, index) => (
            <button
              key={testimonial?.id}
              onClick={() => setActiveTestimonial(index)}
              className={`flex items-center space-x-3 px-6 py-3 rounded-full transition-all duration-300 ${
                activeTestimonial === index
                  ? 'bg-primary text-primary-foreground shadow-forest'
                  : 'bg-white text-text-primary hover:bg-primary/10 hover:text-primary border border-border'
              }`}
            >
              <div className="w-8 h-8 rounded-full overflow-hidden">
                <Image
                  src={testimonial?.image}
                  alt={testimonial?.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-medium">{testimonial?.name?.split(' ')?.[0]}</span>
            </button>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-forest rounded-3xl p-12 text-center text-white">
          <Icon name="MessageCircle" size={48} color="white" className="mx-auto mb-6" />
          <h3 className="font-playfair text-3xl font-bold mb-4">
            Quer Ser Nosso Próximo Cliente Satisfeito?
          </h3>
          <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e descubra como podemos transformar seus ambientes 
            com móveis artesanais únicos e personalizados.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <LeadFormButton
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              className="border-white text-white hover:bg-white hover:text-primary"
            >
              Agendar Consultoria
            </LeadFormButton>
            <LeadFormButton
              variant="outline"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              className="border-white text-white hover:bg-white hover:text-primary"
            >
              WhatsApp
            </LeadFormButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;